/**
 * Returns Expected Style Objects List Based on Disabled Parameter for Tooltip Handle
 * @function getHandleStyle
 * @param {Boolean} disabled
 * @return {Array.<Object>}
 */
export default disabled => disabled
  ? [{
    height: '12px',
    width: '12px',
    marginTop: '-4px',
    backgroundColor: '#FAFCFF',
    border: '4px solid #AFC1E1',
  },
  {
    height: '12px',
    width: '12px',
    marginTop: '-4px',
    backgroundColor: '#FAFCFF',
    border: '4px solid #AFC1E1',
  }]
  : [{
    height: '12px',
    width: '12px',
    marginTop: '-4px',
    backgroundColor: '#FAFCFF',
    border: '4px solid #105EEB',
  },
  {
    height: '12px',
    width: '12px',
    marginTop: '-4px',
    backgroundColor: '#FAFCFF',
    border: '4px solid #105EEB',
  }];
